import React from "react";
import CampaignsList from "../../../components/CampaignsList";
import { usePromotionsBannerQuery } from "hooks/usePromotions";
import { API } from "utils/Helper";
import styled, { keyframes } from "styled-components";

// ─── Skeleton shimmer (same as Promotions) ───
const shimmer = keyframes`
  0%   { background-position: -600px 0; }
  100% { background-position:  600px 0; }
`;

const BannerSkeleton = styled.div`
  width: 100%;
  height: 180px;
  background: linear-gradient(90deg, #2a2e30 25%, #343a3c 50%, #2a2e30 75%);
  background-size: 600px 100%;
  border-radius: 15px;
  margin-bottom: 25px;
  animation: ${shimmer} 1.4s infinite linear;
`;

function OffersPage() {
  const { data: banners = [], isLoading: bannerLoading } = usePromotionsBannerQuery("offers");
  const banner = banners.length > 0 ? banners[0] : null;

  const defaultBanner = "/assets/bcimages/bchome/bcgame-home-banner.webp";
  let imgSrc = defaultBanner;
  if (banner && banner.image_url) {
    imgSrc =
      banner.image_url.startsWith("http") || banner.image_url.startsWith("/uploads")
        ? banner.image_url.startsWith("http")
          ? banner.image_url
          : `${API}${banner.image_url}`
        : banner.image_url;
  }

  return (
    <div style={{ width: "100%" }}>
      <h4 style={{ fontWeight: "bold", paddingBottom: "15px", color: "#fff", fontSize: "1.5rem" }}>
        Offers
      </h4>

      {/* Full-width Banner */}
      {bannerLoading ? (
        <BannerSkeleton />
      ) : (
        <div style={{ width: "100%", marginBottom: "25px" }}>
          {banner && banner.link_url ? (
            <a href={banner.link_url} style={{ display: "block", width: "100%" }}>
              <img
                src={imgSrc}
                alt="Offers Banner"
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "180px",
                  objectFit: "cover",
                  objectPosition: "center",
                  borderRadius: "15px",
                  display: "block",
                }}
              />
            </a>
          ) : (
            <img
              src={imgSrc}
              alt="Offers Banner"
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "180px",
                objectFit: "cover",
                objectPosition: "center",
                borderRadius: "15px",
                display: "block",
              }}
            />
          )}
        </div>
      )}

      {/* Campaign Cards — same grid component used by Promotions */}
      <div className="main-card-promot" style={{ marginTop: "20px" }}>
        <CampaignsList showOn="offers" />
      </div>
    </div>
  );
}

export default OffersPage;
